import { normalizeAxiosError } from '@/http/errors';
import { resolveApiErrorCode } from '@/lib/subscriptionPaymentResume';

export type AuthSessionMode = 'login' | 'register';

export const USER_NOT_REGISTERED_API_CODE = 'HTTP.ERROR.403.USER.NOT.REGISTERED';

export type GoogleSignInFailure = 'cancelled' | 'notRegistered' | 'other';

const CANCELLED_POPUP_CODES = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
  'auth/user-cancelled',
]);

export function classifyGoogleSignInError(err: unknown): GoogleSignInFailure {
  const firebaseCode = (err as { code?: unknown } | null)?.code;
  if (typeof firebaseCode === 'string' && CANCELLED_POPUP_CODES.has(firebaseCode)) {
    return 'cancelled';
  }

  if (resolveApiErrorCode(normalizeAxiosError(err)) === USER_NOT_REGISTERED_API_CODE) {
    return 'notRegistered';
  }

  return 'other';
}
